var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{class:_vm.$style.forwardName},[_vm._v(" "+_vm._s(_vm.$t('forwardFrom'))+" "+_vm._s(_vm.message.payload.name)+" ")]),_c('MessageContent',{attrs:{"message":_vm.forwardedMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }